import { Dialog, Button, Box, Typography, DialogContent } from "@material-ui/core";
import { openModal, closeModal } from "actions/modalActions";
import { useTypeSelectors } from "hooks/useTypeSelectors";
import { FC } from "react";
import { useDispatch } from "react-redux";
import { useDashboardModalStyles } from "./styles";
import Close from "@material-ui/icons/Close";

interface DashboardModalWindowProps {
  buttonType: "icon" | "text" | "custom" | "none";
  children: any;
  modal_name: string;
  fullWidth?: boolean;
  buttonText?: string;
  modalTitle?: string;
  modalDescription?: string;
  isDisabled?: boolean;
  customButtonElement?: any;
  customOnClick?: any;
  hasGraph?: boolean;
}

export const DashboardModalWindow: FC<DashboardModalWindowProps> = ({
  buttonType,
  fullWidth,
  children,
  modal_name,
  buttonText,
  modalTitle,
  modalDescription,
  isDisabled,
  customButtonElement,
  customOnClick,
  hasGraph
}) => {
  const classes = useDashboardModalStyles();

  const dispatch = useDispatch();

  const { isOpen, modalName } = useTypeSelectors((state) => state.modalState);

  const triggerOnClick = () => {
    if (!customOnClick) {
      dispatch(openModal(modal_name));
    } else {
      dispatch(customOnClick);
    }
  };

  return (
    <>
      {buttonType === "text" && (
        <Button
          className={classes.openBtn}
          variant="text"
          fullWidth={fullWidth}
          onClick={triggerOnClick}
          disabled={isDisabled}
        >
          {buttonText}
        </Button>
      )}{" "}
      {buttonType === "custom" && (
        <Box
          className={`${classes.customButtonElement} ${isDisabled ? classes.disabledButton : ""}`}
          onClick={triggerOnClick}
        >
          {customButtonElement}
        </Box>
      )}
      <Dialog
        className={`${classes.root}`}
        open={isOpen && modalName === modal_name}
        onClose={() => dispatch(closeModal())}
        BackdropProps={{
          classes: {
            root: classes.backDrop,
          },
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent className={`${classes.dialogContent} ${hasGraph && classes.graphHead}`}>
          <Box>
            <Typography className={classes.title}>{modalTitle}</Typography>
            <Typography className={classes.description}>{modalDescription}</Typography>
          </Box>
          <Button
            className={classes.closeBtn}
            variant="text"
            onClick={() => dispatch(closeModal())}
          >
            <Close />
          </Button>
        </DialogContent>
        <Box className={`${classes.content} ${hasGraph && classes.graphContent}`}>
          {children}
        </Box>
      </Dialog>
    </>
  );
};
